<div class="w-100 text-center">
    <h1>{{'COMMON.LABEL.NEWS' | translate}}</h1>
</div>
<div class="prada-light-gray-bg">
    <prada-news [news]="news"
        [pageSize]="pagination.size"
        (newsClick)="onNewsClick($event)"></prada-news>
</div>